import React, { useRef } from 'react'
import emailjs from '@emailjs/browser'
import { ContactConfig } from '../../constants'
import swal from 'sweetalert'
import ContactImg from '../../assets/img/Contact.jpg'

const Contact = () => {
    const form = useRef()

    const sendEmail = (e) => {
        e.preventDefault()

        const serviceId = ContactConfig.service_id
        const templateId = ContactConfig.template_id
        const publicKey = ContactConfig.public_key
        emailjs.sendForm(serviceId, templateId, form.current, publicKey).then((result) => {
            dialogModal(ContactConfig.alert.title, ContactConfig.alert.ID.message)
            console.log(result.text)
        }, (error) => {
            dialogModal(ContactConfig.alertError.title, ContactConfig.alertError.ID.message, 'error')
            console.log(error.text)
        })
    }

    const dialogModal = (title, message, type = 'success') => {
        swal(title, message, type)
    }

    return (
        <section id="contact" className='Lato-font mt-4 overflow-x-hidden'>
            <div className="sm:flex sm:justify-around sm:items-center">
                <div className="contact-image hidden sm:w-1/2 sm:flex">
                    <img src={ContactImg} alt="Contact Image" class='md:max-w-[500px] sm:max-w-[400px]'/>
                </div>
                <div className="form-contact px-4 sm:w-1/2 md:w-1/3">
                    <div className="contact-header flex justify-center">
                        <h1 className='text-primary text-2xl font-bold'>Contact Me</h1>
                    </div>
                    <form ref={form} onSubmit={sendEmail} className='mt-4 px-4 sm:px-0'>
                        <div className="form-input my-1.5">
                            <input type="text" id="subject" name='user_name' placeholder='Subject' className='contact-name w-full px-4 py-2 outline-none text-primary border-[0.1px] border-primary rounded-sm bg-transparent' autocomplete='off'/>
                        </div>
                        <div className="form-input my-1.5">
                            <input type="email" id="from" name='user_email' placeholder='Email Adrress' className='w-full px-4 py-2 outline-none text-primary border-[0.1px] border-primary rounded-sm bg-transparent' autocomplete='off'/>
                        </div>
                        <div className="form-input">
                            <textarea id="message" name='message' className='hidden-scrollbar w-full border-[0.1px] border-primary rounded-sm outline-none px-4 py-2 h-20 bg-transparent text-primary' placeholder='Message' autocomplete='off'></textarea>
                        </div>
                        <div className="button">
                            <button className='w-full py-2 text-light bg-primary rounded-sm border-[0.1px] border-transparent transition duration-500 ease-in-out hover:bg-transparent hover:border-primary hover:text-primary'>Send</button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default Contact